(() => {
  'use strict';

  // Loaded only for the EN/US storefront by theme.liquid.
  // Do not check hostname here: Shopify theme preview uses a different host.
  document.documentElement.lang = 'en';
  if (window.Shopify) {
    try { window.Shopify.locale = 'en'; } catch (_) {}
    try { window.Shopify.language = 'en'; } catch (_) {}
  }

  const replacements = [
    ['Obwód klatki piersiowej', 'Chest'],
    ['Szerokość klatki piersiowej', 'Chest Width'],
    ['Szerokość w klatce piersiowej', 'Chest Width'],
    ['Szerokość w klatce', 'Chest Width'],
    ['Szerokosc w klatce piersiowej', 'Chest Width'],
    ['Szerokosc w klatce', 'Chest Width'],
    ['Długość całkowita', 'Body Length'],
    ['Długosć całkowita', 'Body Length'],
    ['Dlugosc calkowita', 'Body Length'],
    ['Długość rękawa', 'Sleeve Length'],
    ['Długosć rękawa', 'Sleeve Length'],
    ['Przewodnik po rozmiarach', 'Size Guide'],
    ['Tabela rozmiarów', 'Size Guide'],
    ['Wymiary', 'Size Guide'],
    ['WYMIARY', 'Size Guide'],
    ['wymiary', 'Size Guide'],
    ['Jak mierzyć?', 'How to Measure'],
    ['Jak mierzyć', 'How to Measure'],
    ['Klatka piersiowa', 'Chest'],
    ['Szerokość', 'Width'],
    ['Szerokosc', 'Width'],
    ['Długość', 'Body Length'],
    ['Długosć', 'Body Length'],
    ['Dlugosc', 'Body Length'],
    ['Rozmiary', 'Sizes'],
    ['Rozmiar', 'Size'],
    ['Rękaw', 'Sleeve'],
    ['Rekaw', 'Sleeve'],
    ['Ramiona', 'Shoulders'],
    ['Ramię', 'Shoulder'],
    ['Ramie', 'Shoulder'],
    ['Talia', 'Waist'],
    ['Biodra', 'Hips'],
    ['Wzrost', 'Height'],
    ['Cale', 'Inches'],
    ['Zamknij', 'Close']
  ];

  const attributeNames = [
    'title', 'aria-label', 'placeholder', 'data-title', 'data-label',
    'data-text', 'data-content', 'alt'
  ];
  const observedRoots = new WeakSet();
  const processedFrames = new WeakSet();

  function translateString(value) {
    if (!value || typeof value !== 'string') return value;
    let out = value;
    for (const [pl, en] of replacements) {
      if (out.includes(pl)) out = out.split(pl).join(en);
    }
    return out;
  }

  function translateTextNode(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE) return;
    const parent = node.parentElement;
    if (parent && /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/i.test(parent.tagName)) return;
    const raw = node.nodeValue || '';
    let next = translateString(raw);
    if (/^\s*wymiary\s*$/i.test(raw)) next = raw.replace(/wymiary/i, 'Size Guide');
    if (next !== raw) node.nodeValue = next;
  }

  function translateElement(el) {
    if (!el || el.nodeType !== Node.ELEMENT_NODE) return;

    for (const name of attributeNames) {
      if (!el.hasAttribute(name)) continue;
      const current = el.getAttribute(name);
      const next = translateString(current);
      if (next !== current) el.setAttribute(name, next);
    }

    if ((el.tagName === 'INPUT' || el.tagName === 'BUTTON') && typeof el.value === 'string') {
      const next = translateString(el.value);
      if (next !== el.value) el.value = next;
    }

    // Pify may use an open or closed Shadow DOM. The closed root is captured
    // by the early attachShadow shim in theme.liquid as __wineteeShadowRoot.
    const shadow = el.shadowRoot || el.__wineteeShadowRoot;
    if (shadow) processRoot(shadow);

    if (el.tagName === 'IFRAME') processIframe(el);
  }

  function processIframe(frame) {
    if (!frame) return;
    const run = () => {
      try {
        const doc = frame.contentDocument;
        if (doc) processRoot(doc);
      } catch (_) {
        // Cross-origin frames are inaccessible to storefront JavaScript.
      }
    };
    run();
    if (!processedFrames.has(frame)) {
      processedFrames.add(frame);
      frame.addEventListener('load', run, { passive: true });
    }
  }

  function translateTree(root) {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      translateTextNode(root);
      return;
    }

    if (root.nodeType === Node.ELEMENT_NODE) translateElement(root);

    let walker;
    try {
      walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
    } catch (_) {
      return;
    }

    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeType === Node.TEXT_NODE) translateTextNode(node);
      else translateElement(node);
    }
  }

  function processRoot(root) {
    if (!root) return;
    translateTree(root);

    if (!observedRoots.has(root)) {
      observedRoots.add(root);
      try {
        const observer = new MutationObserver((mutations) => {
          for (const mutation of mutations) {
            if (mutation.type === 'characterData') translateTextNode(mutation.target);
            if (mutation.type === 'attributes') translateElement(mutation.target);
            mutation.addedNodes.forEach((node) => translateTree(node));
          }
        });
        observer.observe(root, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: attributeNames
        });
      } catch (_) {}
    }
  }

  function sweep() {
    processRoot(document);
    document.querySelectorAll('iframe').forEach(processIframe);
  }

  function run() {
    sweep();

    // Pify initializes asynchronously and often builds the table only when opened.
    [100, 250, 500, 750, 1000, 1500, 2500, 4000, 6000, 10000, 15000].forEach((delay) => {
      window.setTimeout(sweep, delay);
    });

    ['click', 'touchend', 'pointerup', 'keydown'].forEach((eventName) => {
      document.addEventListener(eventName, () => {
        [0, 30, 80, 150, 300, 600, 1200].forEach((delay) => {
          window.setTimeout(sweep, delay);
        });
      }, { passive: eventName !== 'keydown', capture: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
